import React, { Component } from "react";
import HttpUtil from "../../Util/httpUtil";
import Config from "../../Util/config";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Col, Row, Container } from "reactstrap";
import "../../_Content/css/modal-token.css";

const idUsuario = localStorage.getItem('CodUsuario');

class ModalToken extends Component {

    constructor(props) {
        super(props);

        this.state = {
            backdrop: true,
            modal: this.props.modal,
            token: '',
            validarFormulario: false
        };
    }

    handleTokenChange = (event) => {
        this.setState({
            token: event.target.value,
            validarFormulario: event.target.value.length > 0
        });
    }

    confirmar = (event) => {
        event.preventDefault();
        var url = `${Config.urls.API_URL_BASE}Acesso/ValidarToken/${idUsuario}/${this.state.token}`;

        return new Promise((resolve, reject) => {
            HttpUtil.eco_GET(url, (response) => {
                if (!response.data)
                    window.location = "/erro";
                else {
                    localStorage.setItem("Token", this.state.token);
                    window.location = "/arquivos-recentes";
                }
            }, () => {
                window.location = "/erro";
            });
        });
    }

    componentDidMount() {
        this.inputToken.focus();
    }

    render() {
        return (
            <Modal id='modalToken' isOpen={this.state.modal} className={this.props.className}>
                <ModalBody>
                    <Container>
                        <form onSubmit={this.confirmar}>
                            <Row>
                                <Col className='col-sm-10 col'>
                                    <label>Preencha o Token</label>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <input className='token' ref={(input) => { this.inputToken = input; }} onChange={this.handleTokenChange} placeholder='Digite o token fornecido pela Econet' />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="text-center">
                                        <Button type="submit"className='btnEnviarFeedback btn-block' color='success' disabled={!this.state.validarFormulario}>Confirmar</Button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    </Container>
                </ModalBody>
            </Modal>
        );
    }
}

export default ModalToken;


// WEBPACK FOOTER //
// ./src/Componente/ValidarLoginToken/ModalToken.jsx